module.exports = __webpack_public_path__ + "static/media/c104_cd2.84270233.jpeg";